module.exports = "<div class=\"phone-bg\">\n    <div class=\"fromThem\">\n        <p>{{phoneMsg.text}} <span ng-if=\"phoneMsg.text.length\" class=\"link\">https://live.upreach.com/DbOwGI</span></p>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./sources/components/common/phone-msg/phone-msg.html
// module id = 731
// module chunks = 0